import { NavLink, useNavigate } from "react-router-dom";
import {BsBag, BsPerson} from "react-icons/bs"
import {AiOutlineHeart} from "react-icons/ai"
import {PiPackageLight} from "react-icons/pi"
import {RiMenu3Fill} from "react-icons/ri"
import {CiLogout} from "react-icons/ci"
// import {CiMenuFries} from "react-icons/ci"
import logo from "../assets/images/logo2.jpg"
import "../Styles/Component/Navbar.css"
import { useEffect, useState } from "react";
import axios from "axios";
import { url } from "../db/url";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

const Navbar = () => {
    const [showAccount, setShowAccount] = useState(false)
    const [showNavigation, setShowNavigation] = useState(false)
    const [cart, setCart] = useState([])
    const [wishlist, setWishlist] = useState([])

    const navigate = useNavigate()
    const name = Cookies.get("NAME")
    const type = Cookies.get("TYPE")

    useEffect(() => {
        let cart = localStorage.getItem('cart');
        let wishlist = localStorage.getItem('wishlist');
        if (!cart) {
            setCart([]);
            setWishlist([])
        } else {
            setCart(JSON.parse(cart))
        }
        if (!wishlist) {
            setWishlist([])
        } else {
            setWishlist(JSON.parse(wishlist))
        }
    }, [])
    
    const activeStyle = {
        color: "rgb(4, 175, 4)",
    }

    const logout = () => {
        axios.get(`${url}/api/v2/user/logout`, {headers: {Authorization: `Bearer`}})
        .then(res => {
            console.log(res)
            Cookies.remove("TOKEN")
            Cookies.remove("NAME")
            Cookies.remove("ROLE")
            Cookies.remove("TYPE")
            Cookies.remove("SHOP_ID")
            toast.success(res.data.message)
            closeCards()
            navigate("/")
        }).catch(err => {
            toast.error(err.response.data.message)
            console.log(err)
        })
    }

    const showNavbar = () => {
        showNavigation ? setShowNavigation(false) : setShowNavigation(true)
        setShowAccount(false)
    }

    const showAccountCard = () => {
        window.innerWidth <= 750 ? setShowNavigation(false) : setShowNavigation(true)
        setShowAccount(true)
    }
    const showAccountCard2 = () => {
        window.innerWidth <= 750 ? setShowNavigation(false) : setShowNavigation(true)
        showAccount ? setShowAccount(false) : setShowAccount(true)
    }

    const closeCards = () => {
        setShowAccount(false)
        setShowNavigation(false)
    }

    return<>
        <div className="nav" onMouseLeave={() => setShowAccount(false)}>
            <div className="nav_logo">
                <img src={logo} alt="" />
            </div>
            <div className={window.innerWidth <= 750 && showNavigation ? "navigation_links" : window.innerWidth >= 750 ? "navigation_links" : "hide"}>
                <NavLink to={"/"} style = {({isActive}) => isActive? activeStyle : undefined} end>Home</NavLink>
                <NavLink to={"/product"} style = {({isActive}) => isActive? activeStyle : undefined} end>Shop</NavLink>
                {/* <NavLink to={"/pages"} style = {({isActive}) => isActive? activeStyle : undefined} end>Pages</NavLink>
                <NavLink  to={"/contact"} style = {({isActive}) => isActive? activeStyle : undefined} end>Contact</NavLink> */}
            </div>
            <div className="nav_menu">
                
                <div className="nav_icons cart person" onMouseOver={showAccountCard} onClick={showAccountCard2}>
                    <BsPerson/>
                    {
                        !Cookies.get("TOKEN") ? 
                        <div className={showAccount ? "accountList" : "hide"} onMouseLeave={() => setShowAccount(false)}>
                            <button onClick={() => navigate('/signup')}>Signup</button>
                            <button onClick={() => navigate('/signin')}>Signin</button>
                        </div> :
                        <div className={showAccount ? "accountList" : "hide"} onMouseLeave={() => setShowAccount(false)}>
                            <div className="accountHeading" onClick={() => navigate("/account")} style={{cursor: "pointer"}}>
                                <img src="" alt="" />
                                <p>{name}</p>
                            </div>
                            <hr />
                            {
                                type === "Shop" ?
                                <NavLink to={"/dashboard"} style = {({isActive}) => isActive? activeStyle : undefined} end><BsPerson/>My Dashboard</NavLink>  :
                                <NavLink to={"/seller"} style = {({isActive}) => isActive? activeStyle : undefined} end><BsPerson/> Become a Seller</NavLink> 
                            }
                            <NavLink to={"/cart"} style = {({isActive}) => isActive? activeStyle : undefined} end><BsBag/> Cart</NavLink>
                            {/* <NavLink to={"/order"} style = {({isActive}) => isActive? activeStyle : undefined} end><PiPackageLight/> Order</NavLink> */}
                            <NavLink to={"/wishlist"} style = {({isActive}) => isActive? activeStyle : undefined} end><AiOutlineHeart/> Wishlist</NavLink>
                            <span onClick={logout}><CiLogout/> Logout</span>
                        </div>
                    }
                </div>
                <div className="nav_icons cart"  onClick={() => navigate("/cart")}>
                    <p className="count">{cart.length}</p>
                    <BsBag/>
                </div>
                <div className="nav_icons wishlist" onClick={() => navigate("/wishlist")}>
                    <p className="count">{wishlist.length}</p>
                    <AiOutlineHeart/>
                </div>
                <div className="menu" onClick={showNavbar}>
                    <RiMenu3Fill/>
                </div>
            </div>
        </div>
    </>

}

export default Navbar;